export const getQuiz = state => {
  const quizValues = Object.values(state?.appSync?.quizzes || {})
  const quiz = quizValues[0] || null

  if (!quiz) {
    return null
  }

  return quiz
}
